import { defineAsyncComponent } from "vue";

export const WIDGET_SIGNATURES = Object.freeze({
    brand_widget: "brand_widget",
    overview_amount_of_tires_widget: "overview_amount_of_tires_widget",
    overview_bonus_credit_widget: "overview_bonus_credit_widget",
    participating_customers_widget: "participating_customers_widget",
    points_credit_widget: "points_credit_widget",
    rim_widget: "rim_widget",
    last_import_widget: "last_import_widget",
    brand_rim_widget: "brand_rim_widget",
    score_widget: "score_widget",
    dealer_combined_achievement_goals_widget: "dealer_combined_achievement_goals_widget",
    dealer_performance_widget: "dealer_performance_widget",
    booster_ccs_widget: "booster_ccs_widget",
    dealer_list_widget: "dealer_list_widget",
    wholesaler_list_widget: "wholesaler_list_widget",
    tire_achievement_goal_widget: "tire_achievement_goal_widget",
    find_more_about_points_widget: "find_more_about_points_widget",
    score_widget_extended: "score_widget_extended",
    business_unit_widget: "business_unit_widget",
    overview_bonus_credit_widget_extended: 'overview_bonus_credit_widget_extended',
    season_widget: "season_widget",
    season_business_units_widget: "season_business_units_widget",
});

export const WIDGET_SIGNATURE_LIST = Object.freeze(Object.values(WIDGET_SIGNATURES));

export const widgetRegistry = {
    [WIDGET_SIGNATURES.brand_widget]: defineAsyncComponent(() =>
        import("@/components/Widgets/BrandWidget.vue")
    ),
    [WIDGET_SIGNATURES.overview_amount_of_tires_widget]: defineAsyncComponent(() =>
        import("@/components/Widgets/OverviewAmountOfTiresWidget.vue")
    ),
    [WIDGET_SIGNATURES.overview_bonus_credit_widget]: defineAsyncComponent(() =>
        import("@/components/Widgets/OverviewBonusCreditWidget.vue")
    ),
    [WIDGET_SIGNATURES.participating_customers_widget]: defineAsyncComponent(() =>
        import("@/components/Widgets/ParticipatingCustomersWidget.vue")
    ),
    [WIDGET_SIGNATURES.points_credit_widget]: defineAsyncComponent(() =>
        import("@/components/Widgets/PointsCreditWidget.vue")
    ),
    [WIDGET_SIGNATURES.rim_widget]: defineAsyncComponent(() =>
        import("@/components/Widgets/RimWidget.vue")
    ),
    [WIDGET_SIGNATURES.last_import_widget]: defineAsyncComponent(() =>
        import("@/components/Widgets/LastImportWidget.vue")
    ),
    [WIDGET_SIGNATURES.brand_rim_widget]: defineAsyncComponent(() =>
        import("@/components/Widgets/BrandRimCombinedWidget.vue")
    ),
    [WIDGET_SIGNATURES.score_widget]: defineAsyncComponent(() =>
        import("@/components/Widgets/ScoreWidget.vue")
    ),
    [WIDGET_SIGNATURES.dealer_combined_achievement_goals_widget]: defineAsyncComponent(() =>
        import("@/components/Widgets/DealerCombinedAchievementGoals.vue")
    ),
    [WIDGET_SIGNATURES.dealer_performance_widget]: defineAsyncComponent(() =>
        import("@/components/Widgets/DealerPerformanceWidget.vue")
    ),
    [WIDGET_SIGNATURES.booster_ccs_widget]: defineAsyncComponent(() =>
        import("@/components/Widgets/BoosterCcsWidget.vue")
    ),
    [WIDGET_SIGNATURES.dealer_list_widget]: defineAsyncComponent(() =>
        import("@/components/Widgets/DealerTableWidget.vue")
    ),
    [WIDGET_SIGNATURES.wholesaler_list_widget]: defineAsyncComponent(() =>
        import("@/components/Widgets/TableWidget.vue")
    ),
    [WIDGET_SIGNATURES.score_widget_extended]: defineAsyncComponent(() =>
        import("@/components/Widgets/ScoreWidgetExtended.vue")
    ),
    [WIDGET_SIGNATURES.business_unit_widget]: defineAsyncComponent(() =>
        import("@/components/Widgets/BusinessUnitsWidget.vue")
    ),
    [WIDGET_SIGNATURES.season_widget]: defineAsyncComponent(() =>
        import("@/components/Widgets/SeasonWidget.vue")
    ),
    [WIDGET_SIGNATURES.season_business_units_widget]: defineAsyncComponent(() =>
        import("@/components/Widgets/SeasonBusinessUnitsWidget.vue")
    ),
};

export function resolveWidgetComponent(signature) {
    return widgetRegistry[signature] || null;
}
